/* import __COLOCATED_TEMPLATE__ from './mobile-linking.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { setGrantAction } from '@banking/ui/workflows/investments';
import environment from '@square/environment-utils/environment';
const CONTAINER_ID = '#cash-app-pay';
let Linking = (_class = class Linking extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor, this);
    _initializerDefineProperty(this, "cashAppPayKitSdk", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _initializerDefineProperty(this, "merchantInfo", _descriptor4, this);
    _defineProperty(this, "_goBack", () => null);
    _defineProperty(this, "close", () => null);
    _defineProperty(this, "beginPayKit", () => Promise.resolve());
    // https://developers.cash.app/docs/pay-kit-technical-reference#restart
    // restart must be called whenever the buyer leaves the screen
    _defineProperty(this, "restartPayKit", () => Promise.resolve());
    this._goBack = args.goBack;
    this.close = args.close;
    this.beginPay();
  }
  async beginPay() {
    const {
      error
    } = await this.initCashAppScript();

    // display an error message breifly before going back to the splash screen
    if (error) {
      this.close();
    }
  }
  async initCashAppScript() {
    const onSuccessCallback = result => {
      const {
        grants: {
          deposits: {
            grantId
          }
        },
        customerProfile: {
          cashtag
        }
      } = result;
      this.close();
      this.investmentsWorkflow.emit(setGrantAction(grantId, cashtag));
    };
    try {
      const env = environment();
      const redirectURL = env.isStaging ? 'https://squareupstaging.com/dashboard/balances' : 'https://squareup.com/dashboard/balances';
      await this.cashAppPayKitSdk.initialize({
        container: CONTAINER_ID,
        redirectURL,
        onSuccessCallback,
        actionData: this.merchantInfo,
        isMobileFlow: true
      });
      return {};
    } catch (error) {
      this.sentry.captureException(error);
      return {
        error
      };
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashAppPayKitSdk", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "merchantInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      primary_alias: '',
      logo_url: ''
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "beginPay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "beginPay"), _class.prototype), _class);
export { Linking as default };